import { styled } from 'styled-components';

export const StyledDimmer = styled.div`
  display: flex;
  position: absolute;
  top: 0 !important;
  left: 0 !important;
  width: 100%;
  height: 100%;
  text-align: center;
  vertical-align: middle;
  background-color: ${({ theme, $opacityType }) =>
    theme.applyOpacity(
      theme.colours.canvas.secondary.weak,
      $opacityType || 'overlay',
    )};
  line-height: 1;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation-duration: ${({ theme }) => theme.animation.duration.slow};
  animation-duration: ${({ theme }) => theme.animation.duration.slow};
  transition: background-color ${({ theme }) => theme.animation.duration.slow}
    ${({ theme }) => theme.animation.easing.static};
  flex-direction: column;
  align-items: center;
  justify-content: center;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  will-change: opacity;
  z-index: ${({ $zIndex }) => $zIndex || 98};
  margin: ${({ $margin }) => $margin || 0};

  > div + p {
    margin-top: ${({ theme }) => theme.sizing.small};
  }
`;
